<template>
	<div class="component-section" @click="handleClick">
		<h3 class="section-title">Navigation</h3>
		<div class="navigation-content">
			<div class="tabs-section">
				<Tabs v-model:value="activeTab">
					<TabList>
						<Tab value="0">Tab 1</Tab>
						<Tab value="1" :disabled="true" style="pointer-events: none; opacity: 0.7;">Tab 2</Tab>
						<Tab value="2" :disabled="true" style="pointer-events: none; opacity: 0.7;">Tab 3</Tab>
					</TabList>
					<TabPanels>
						<TabPanel value="0">
							<p>Content for Tab 1</p>
						</TabPanel>
						<TabPanel value="1">
							<p>Content for Tab 2</p>
						</TabPanel>
						<TabPanel value="2">
							<p>Content for Tab 3</p>
							<Timeline :value="timelineEvents">
								<template #content="slotProps">
									<small>{{ slotProps.item.status }}</small>
								</template>
							</Timeline>
						</TabPanel>
					</TabPanels>
				</Tabs>
			</div>

		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue"
import Tabs from "primevue/tabs"
import TabList from "primevue/tablist"
import Tab from "primevue/tab"
import TabPanels from "primevue/tabpanels"
import TabPanel from "primevue/tabpanel"
import Timeline from "primevue/timeline"

const emit = defineEmits<{
	(e: "elementClick", event: MouseEvent): void
}>()

const activeTab = ref("0") // Always keep first tab active for color picker

const timelineEvents = [
	{ status: "Ordered", date: "15/10/2020 10:30", icon: "pi pi-shopping-cart" },
	{ status: "Processing", date: "15/10/2020 14:00", icon: "pi pi-cog" },
	{ status: "Shipped", date: "15/10/2020 16:15", icon: "pi pi-envelope" },
]


const handleClick = (event: MouseEvent) => {
	emit("elementClick", event)
}
</script>

<style lang="scss" scoped>
.component-section {
	background: white;
	border-radius: 8px;
	padding: 1.5rem;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	margin-bottom: 1rem;
}

.section-title {
	font-size: 1.2rem;
	font-weight: 600;
	margin-bottom: 1rem;
	color: #374151;
	border-bottom: 2px solid #e5e7eb;
	padding-bottom: 0.5rem;
}

.navigation-content {
	display: flex;
	flex-direction: column;
	gap: 2rem;
}

.tabs-section {
	width: 100%;
}

/* Make only the first tab interactive for color picker */
.tabs-section :deep(.p-tab:first-child) {
	cursor: pointer;
	position: relative;
}

.tabs-section :deep(.p-tab:first-child):hover {
	background-color: rgba(0, 0, 0, 0.05);
}

/* Visual indicator that first tab is for color picking */
.tabs-section :deep(.p-tab:first-child)::after {
	content: "🎨";
	position: absolute;
	top: -5px;
	right: -5px;
	font-size: 12px;
	opacity: 0.6;
}


.field-label {
	font-size: 0.875rem;
	font-weight: 500;
	color: #6b7280;
}

</style>